import FoodIntroductions from '../sections/foodIntroductions/foodIntroductions';

export default function FoodIntroductionsPage() {
  return (
    <div className="section-page">
      <FoodIntroductions />
    </div>
  );
}
